import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { APIConstants } from '@shared/constants';
import { BaseAPI } from '@core/services';
import { PermittedAccess } from '../../fleets/models/permitted-access.model';

@Injectable({ providedIn: 'root' })
export class PermitsApiService {
  constructor(private baseAPI: BaseAPI) {}

  update(permit: PermittedAccess, truckId, driverId): Observable<any> {
    return truckId
      ? this.updateTruckPermit(permit, truckId)
      : driverId
        ? this.updateDriverPermit(permit, driverId)
        : throwError('id is not recognized');
  }

  updateDriverPermit(permit, driverId): Observable<any> {
    return this.baseAPI.put(APIConstants.UPDATE_DRIVER_PERMIT + permit.id, {...permit, driverId});
  }

  updateTruckPermit(permit, truckId): Observable<any> {
    return this.baseAPI.put(APIConstants.UPDATE_TRUCK_PERMIT + permit.id, {...permit, truckId});
  }
}
